import { render, staticRenderFns } from "./MultiSelectWrapper.vue?vue&type=template&id=dc80195e"
import script from "./MultiSelectWrapper.vue?vue&type=script&lang=js"
export * from "./MultiSelectWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports